var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "custom-footer" }, [
    _c("div", [
      _c("div", { staticClass: "row footer-margin" }, [
        _c("div", { staticClass: "col-md-4 col-sm-4" }, [
          _c("h3", [_vm._v("Useful links")]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-3" }, [
            _c("ul", [
              _vm.loggedIn
                ? _c(
                    "li",
                    { staticClass: "mb-2" },
                    [
                      _c("router-link", { attrs: { to: "/faq" } }, [
                        _vm._v("FAQs")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.loggedIn
                ? _c(
                    "li",
                    { staticClass: "mb-2" },
                    [
                      _c("router-link", { attrs: { to: "/terms-of-use" } }, [
                        _vm._v("Terms of Use")
                      ])
                    ],
                    1
                  )
                : _c("li", { staticClass: "mb-2" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href: "https://www.hungerhub.com/terms-of-use/"
                        }
                      },
                      [_vm._v("Terms of Use")]
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "mb-2" }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://www.hungerhub.com/privacy-policy/"
          }
        },
        [_vm._v("Privacy Policy")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "address" }, [
      _c("p", [
        _vm._v("\n            180 John Street Toronto ON M5T 1X5\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 col-sm-4" }, [
      _c("h3", [_vm._v("Made with ♥️ in Canada")]),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticClass: "download-text" }, [
          _vm._v("Download our Uncatering™ mobile app")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mb-4" }, [
        _c(
          "a",
          {
            staticClass: "btn p-0 mr-3",
            attrs: {
              href:
                "https://play.google.com/store/apps/details?id=com.uncatering.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
              role: "button"
            }
          },
          [
            _c("img", {
              staticClass: "app-badge",
              attrs: {
                src: require("../assets/img/google-play-badge.png"),
                alt: "Get it on Google Play"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn p-0",
            attrs: {
              href:
                "https://apps.apple.com/ca/app/uncatering-by-hungerhub/id1505624488",
              role: "button"
            }
          },
          [
            _c("img", {
              staticClass: "app-badge",
              attrs: {
                src: require("../assets/img/apple-store-badge.png"),
                alt: "Get it on App Store"
              }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-4 col-sm-4", attrs: { id: "newsletter" } },
      [
        _c("h3", [_vm._v("Need Help?")]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-3" }, [
          _c("span", [
            _vm._v(
              "\n            Start live chat with one of our agents.\n            "
            ),
            _c("br"),
            _vm._v("Weekdays : 9 AM-7 PM\n          ")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 